// extracted by mini-css-extract-plugin
module.exports = {"root":"figure-module--root--1SX72","caption":"figure-module--caption--NKlUf typography-module--small--LkHnY"};